import { BiEventsDataProps, BiEventReturnType } from '~app/pages/SurveyTaking/types';

export const generateEventData = ({
  environment,
  user,
  collector,
  survey,
  currentPage,
}: BiEventsDataProps): BiEventReturnType => {
  const { countryCode, domain, tld } = environment;
  const { package: packageId, id: userId } = user;

  return {
    collector_id: collector?.id,
    collector_type: collector?.type,
    country: countryCode,
    domain_setting: `${domain}.${tld}`,
    footer_status: survey?.design?.footer?.enabled,
    is_custom_theme: survey?.design?.theme?.isCustomTheme,
    is_group_theme: survey?.design?.theme?.isTeamTheme,
    is_stock_theme: survey?.design?.theme?.isStockTheme,
    language: survey?.language.name,
    logo_status: survey?.design?.logo?.enabled,
    package_id: packageId,
    page_count: survey?.pages?.totalCount,
    page_number: currentPage?.position,
    question_count: currentPage?.questionsQM?.totalCount,
    response_quality: '',
    survey_id: survey?.id ?? '',
    survey_language_id: survey?.language.id ?? '',
    survey_owner_user_id: survey?.userId ?? '', // TODO: Still needed?
    survey_style: survey?.format ?? null,
    theme_id: survey?.design?.theme?.id ?? '',
    theme_name: survey?.design?.theme?.name ?? '',
    theme_version: survey?.design?.theme?.version ?? 'V3',
    user_id: userId,
    version: survey?.version ?? 1,

    // browser: '', // TODO: Still needed?
    // collection_mode: '', // TODO: collectionMethod? the values of collectionMethod dont 1-1 map with enum in responseSvc.
    // https://code.corp.surveymonkey.com/devmonkeys/ResponseWeb/blob/develop/responseweb/libs/bi.py#L20-L26. Applies to popup collector only.
    // collector_subtype: null,
    // device: '', // TODO: Still needed?
    // has_instant_results: hasInstantResults, // TODO: Still needed?
    // has_logic: hasLogic, // TODO: Still needed?
    // ip_address: ip, // TODO: Still needed?
    // os: '', // TODO: Still needed?
    // page_is_quiz: '', // TODO: In responseweb, this checks if any question is marked as Quiz. Would survey.quiz suffice?
    // persistent_id: '', // comes from ep202 cookie. TODO: Still needed?
    // questions: '', // We'll have to extract question_type for each question. Do we need this?
    //  TODO: Adding respondentId to SurveyContext means this will be visible in DOM if using ReactDevTools. Still needed?
    // respondent_id: respondentId,
    // session_id: sessionId, // comes from ep201 cookie. TODO: Still needed?
    // survey_completion_option: '', // Not available in Graph. TODO: Still needed?
    // user_agent: '', // TODO: Still needed?
  };
};

export default generateEventData;
